import BaseComponent from './BaseComponent';

class Dropdown extends BaseComponent {
  constructor(componentName){
    super(componentName);
    this.className = componentName;
  }

  init(component) {
    this.addCustomEvents(component);
  }

  addCustomEvents(component) {
    const target   = component.element.getAttribute('data-dropdown-target')
    const dropdown = document.querySelector(`div[data-target="${target}"]`);
    const links    = document.getElementsByClassName(this.className);
    let timeOut;

    if(target === 'dropdown--products') {
      const categories = dropdown.getElementsByClassName('cmp-dropdown');
      for(let category of categories) {
        category.addEventListener('mouseover', (e) => {
          const color = category.getAttribute('data-color');
          category.style.borderLeft = `5px solid ${color}`;
        })

        category.addEventListener('mouseleave', (e) => {
          category.style.borderLeft = `5px solid transparent`;
        })
      }

      dropdown.addEventListener('mouseleave', (e) => {
        if(e.target.contains(dropdown)) {
          setTimeout(() => {
            dropdown.classList.remove('visible');
          }, 300)
        }
      })

      dropdown.addEventListener('mouseout', (e) => {
        if(e.target.contains(dropdown)) {
          setTimeout(() => {
            dropdown.classList.remove('visible');
          }, 300)
        }
      })
    }

    component.element.addEventListener('mouseover', (e) => {
      timeOut = setTimeout(() => {
        if(!!dropdown) {
          dropdown.classList.add('visible');
        }
        if(target === 'dropdown--categories') {
          const categoryId = parseInt(component.element.getAttribute('data-category-id'));
          this.updateActiveOption(dropdown, categoryId);
        }

        // Remove other hovers
        for(let link of links) {
          link.classList.remove('being-hovered');
        }

        component.element.classList.add('being-hovered');
      }, 300);
    });

    component.element.addEventListener('mouseleave', (e) => {
      clearTimeout(timeOut);
    });

    component.element.addEventListener('mouseout', (e) => {
      clearTimeout(timeOut);
    });
  }

  updateActiveOption(dropdown, categoryId) {
    const listWrappers = dropdown.getElementsByClassName('list-wrapper');

    for (let list of listWrappers) {
      const listCategoryId = parseInt(list.getAttribute('data-category-id'));

      if (categoryId !== listCategoryId) {
        list.classList.remove('visible');
      } else {
        list.classList.add('visible');
      }
    }
  }
}

export default Dropdown;
